/** Extra UI copy merged last. Brand title and strategy names stay identical in every language. */

const STRATEGY_TITLES = {
  tyr: 'TYR',
  ares: 'ARES',
  ascalafo: 'ASCÁLAFO',
  deimos: 'DEIMOS',
  fobos: 'FOBOS',
  bes: 'BES',
  janus: 'JANUS',
  hraesvelgr: 'HRÆSVELGR',
  eos: 'EOS',
  artemis: 'ARTEMIS',
  helios: 'HELIOS',
  hyperion: 'HYPERION',
  horai: 'HORAI',
  theia: 'THEIA',
  astraeus: 'ASTRAEUS',
  phaethon: 'PHAETHON',
  hemera: 'HEMERA',
  selene: 'SELENE',
  asteria: 'ASTERIA',
  aether: 'AETHER',
  heimdall: 'HEIMDALL',
  metis: 'METIS',
};

const brand = {
  home: { hero: { title: 'HMA Quant Strategies' } },
  strategies: { strategyNames: STRATEGY_TITLES },
};

export const extraEn = {
  ...brand,
  metrics: {
    cagr: 'CAGR',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    calmar: 'Calmar',
    maxDD: 'Max DD',
    totalReturn: 'Total Return',
    winRate: 'Win Rate',
    profitFactor: 'Profit Factor',
    volatility: 'Volatility',
    equityCurve: 'Equity Curve',
    drawdown: 'Drawdown',
    annualReturns: 'Annual Returns',
    trades: 'Trades',
    totalTrades: 'Total Trades',
    expectancy: 'Expectancy',
    avgWin: 'Avg Win',
    avgLoss: 'Avg Loss',
    tabs: {
      equity: 'Equity Curve',
      drawdown: 'Drawdown',
      annual: 'Annual Returns',
      trades: 'Trades',
    },
  },
  cookies: {
    text: 'We use cookies for authentication and to improve our service. By continuing, you consent to essential cookies.',
    readPolicy: 'Read our',
    privacyPolicy: 'Privacy Policy',
    accept: 'Accept',
    reject: 'Reject non-essential',
  },
  reportCard: {
    content: 'Report contents',
    signalsHint: 'Specific signals from all strategies + market reports + Quant Macro views',
    asset: 'Asset',
    direction: 'Direction',
    entry: 'Entry',
    confidence: 'Confidence',
  },
  questionnaire: {
    progress: 'Question {n} of {total}',
    completePct: '{pct}% complete',
    cancel: 'Cancel',
    risk_tolerance: {
      q: 'What is your risk tolerance?',
      low: 'Low — I prefer to preserve capital',
      medium: 'Medium — a balance of risk and return',
      high: 'High — I want maximum return',
    },
    max_drawdown: {
      q: 'What maximum drop can you tolerate in your investment?',
      low: 'Less than 15% — I cannot tolerate large losses',
      medium: '15–30% — I can handle moderate drops',
      high: 'More than 30% — drawdowns do not worry me',
    },
    investment_horizon: {
      q: 'What is your investment horizon?',
      short: 'Less than 1 year',
      medium: '1–5 years',
      long: 'More than 5 years',
    },
    investment_goal: {
      q: 'What is your main objective?',
      preservation: 'Preserve capital',
      income: 'Generate a stable income stream',
      growth: 'Moderate growth',
      aggressive_growth: 'Maximum growth',
    },
    volatility_preference: {
      q: 'How do you feel about volatility?',
      low: 'I prefer minimal volatility',
      medium: 'Moderate volatility is fine',
      high: 'High volatility is not a problem',
    },
  },
  models: {
    conservative: {
      name: 'Conservative',
      description: 'Lower risk, capital preservation with moderate growth.',
      riskLevel: 'Low',
      targetReturn: '12–15% a year',
      targetMaxDD: '−15% to −20%',
    },
    moderate: {
      name: 'Moderate',
      description: 'Balance of risk and return across several strategy types.',
      riskLevel: 'Medium',
      targetReturn: '18–22% a year',
      targetMaxDD: '−20% to −28%',
    },
    aggressive: {
      name: 'Aggressive',
      description: 'Higher risk, more leverage, larger drawdowns.',
      riskLevel: 'High',
      targetReturn: '35–50% a year',
      targetMaxDD: '−35% to −50%',
    },
    balanced: {
      name: 'Balanced',
      description: 'Equal-weight mix across timing, momentum, neutral and all-weather sleeves.',
      riskLevel: 'Medium-Low',
      targetReturn: '15–18% a year',
      targetMaxDD: '−18% to −25%',
    },
    growth: {
      name: 'Growth',
      description: 'Long-term growth with a controlled volatility sleeve.',
      riskLevel: 'Medium-High',
      targetReturn: '25–35% a year',
      targetMaxDD: '−25% to −35%',
    },
    income: {
      name: 'Income',
      description: 'Lower volatility mix aimed at a smoother return stream.',
      riskLevel: 'Very Low',
      targetReturn: '10–13% a year',
      targetMaxDD: '−12% to −18%',
    },
  },
  riskProfiles: {
    Low: 'Low',
    'Low-Medium': 'Low-Medium',
    Medium: 'Medium',
    'Medium-High': 'Medium-High',
    High: 'High',
    'Very High': 'Very High',
  },
  ui: {
    snapshotSameStart: '100 = same start',
    expectedCagr: 'Expected CAGR',
    expertPortfolios: 'Expert-designed portfolios',
    comparisonTitle: 'Strategy comparison',
    comparisonLead: 'Select strategies to compare side-by-side performance metrics',
    riskLevel: 'Risk level',
    targetReturn: 'Target return',
    composition: 'Composition',
    loadingPortfolios: 'Loading portfolios…',
    noSavedPortfolios: 'No saved portfolios yet',
    deletePortfolioConfirm: 'Delete this portfolio?',
    portfolioDeleted: 'Portfolio deleted',
    deleteError: 'Could not delete',
    na: 'N/A',
  },
  terminalApp: {
    active: 'ACTIVE',
    account: 'Account',
    exit: 'Exit',
  },
  terminalChrome: {
    lab: 'Quant Lab — educational simulations · not investment advice',
    modules: '{n} / {total} modules active',
  },
  pageTitle: {
    quantLab: 'Quant Lab · HMA Quant Strategies',
    terminal: 'Terminal · HMA Quant Strategies',
  },
};

export const extraEs = {
  ...brand,
  metrics: {
    cagr: 'CAGR',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    calmar: 'Calmar',
    maxDD: 'Máx. DD',
    totalReturn: 'Rentabilidad total',
    winRate: 'Tasa de acierto',
    profitFactor: 'Factor de beneficio',
    volatility: 'Volatilidad',
    equityCurve: 'Curva de capital',
    drawdown: 'Caída máxima',
    annualReturns: 'Rentabilidades anuales',
    trades: 'Operaciones',
    totalTrades: 'Operaciones totales',
    expectancy: 'Expectativa',
    avgWin: 'Ganancia media',
    avgLoss: 'Pérdida media',
    tabs: {
      equity: 'Curva de capital',
      drawdown: 'Caída máxima',
      annual: 'Rentabilidades anuales',
      trades: 'Operaciones',
    },
  },
  cookies: {
    text: 'Usamos cookies para autenticación y para mejorar el servicio. Al continuar, aceptas las cookies esenciales.',
    readPolicy: 'Lee nuestra',
    privacyPolicy: 'Política de privacidad',
    accept: 'Aceptar',
    reject: 'Rechazar no esenciales',
  },
  reportCard: {
    content: 'Contenido del informe',
    signalsHint: 'Señales de las estrategias + informes de mercado + visiones Quant Macro',
    asset: 'Activo',
    direction: 'Dirección',
    entry: 'Entrada',
    confidence: 'Confianza',
  },
  questionnaire: {
    progress: 'Pregunta {n} de {total}',
    completePct: '{pct}% completado',
    cancel: 'Cancelar',
    risk_tolerance: {
      q: '¿Cuál es tu tolerancia al riesgo?',
      low: 'Bajo — prefiero preservar capital',
      medium: 'Medio — equilibrio entre riesgo y retorno',
      high: 'Alto — busco el máximo retorno',
    },
    max_drawdown: {
      q: '¿Qué caída máxima puedes tolerar en tu inversión?',
      low: 'Menos del 15% — no tolero grandes pérdidas',
      medium: '15–30% — puedo soportar caídas moderadas',
      high: 'Más del 30% — las caídas no me preocupan',
    },
    investment_horizon: {
      q: '¿Cuál es tu horizonte de inversión?',
      short: 'Menos de 1 año',
      medium: '1–5 años',
      long: 'Más de 5 años',
    },
    investment_goal: {
      q: '¿Cuál es tu objetivo principal?',
      preservation: 'Preservar capital',
      income: 'Generar renta estable',
      growth: 'Crecimiento moderado',
      aggressive_growth: 'Máximo crecimiento',
    },
    volatility_preference: {
      q: '¿Cómo te sientes con la volatilidad?',
      low: 'Prefiero la mínima volatilidad',
      medium: 'La volatilidad moderada está bien',
      high: 'La alta volatilidad no es un problema',
    },
  },
  models: {
    conservative: {
      name: 'Conservadora',
      description: 'Menor riesgo, preservación de capital con crecimiento moderado.',
      riskLevel: 'Bajo',
      targetReturn: '12–15% anual',
      targetMaxDD: '−15% a −20%',
    },
    moderate: {
      name: 'Moderada',
      description: 'Equilibrio entre riesgo y retorno entre varios tipos de estrategia.',
      riskLevel: 'Medio',
      targetReturn: '18–22% anual',
      targetMaxDD: '−20% a −28%',
    },
    aggressive: {
      name: 'Agresiva',
      description: 'Más riesgo, más apalancamiento, drawdowns más profundos.',
      riskLevel: 'Alto',
      targetReturn: '35–50% anual',
      targetMaxDD: '−35% a −50%',
    },
    balanced: {
      name: 'Equilibrada',
      description: 'Mezcla a pesos iguales de timing, impulso, neutral y todo clima.',
      riskLevel: 'Medio-bajo',
      targetReturn: '15–18% anual',
      targetMaxDD: '−18% a −25%',
    },
    growth: {
      name: 'Crecimiento',
      description: 'Crecimiento a largo plazo con un tramo de volatilidad controlada.',
      riskLevel: 'Medio-alto',
      targetReturn: '25–35% anual',
      targetMaxDD: '−25% a −35%',
    },
    income: {
      name: 'Renta',
      description: 'Mezcla de menor volatilidad para una senda de retorno más suave.',
      riskLevel: 'Muy bajo',
      targetReturn: '10–13% anual',
      targetMaxDD: '−12% a −18%',
    },
  },
  riskProfiles: {
    Low: 'Bajo',
    'Low-Medium': 'Bajo-medio',
    Medium: 'Medio',
    'Medium-High': 'Medio-alto',
    High: 'Alto',
    'Very High': 'Muy alto',
  },
  ui: {
    snapshotSameStart: '100 = mismo inicio',
    expectedCagr: 'CAGR esperado',
    expertPortfolios: 'Carteras diseñadas por expertos',
    comparisonTitle: 'Comparación de estrategias',
    comparisonLead: 'Elige estrategias para comparar métricas de rendimiento',
    riskLevel: 'Nivel de riesgo',
    targetReturn: 'Retorno objetivo',
    composition: 'Composición',
    loadingPortfolios: 'Cargando carteras…',
    noSavedPortfolios: 'Aún no hay carteras guardadas',
    deletePortfolioConfirm: '¿Eliminar esta cartera?',
    portfolioDeleted: 'Cartera eliminada',
    deleteError: 'No se pudo eliminar',
    na: 'N/D',
  },
  terminalApp: {
    active: 'ACTIVO',
    account: 'Cuenta',
    exit: 'Salir',
  },
  terminalChrome: {
    lab: 'Lab cuantitativo — simulaciones educativas · no es asesoramiento de inversión',
    modules: '{n} / {total} módulos activos',
  },
  pageTitle: {
    quantLab: 'Lab cuantitativo · HMA Quant Strategies',
    terminal: 'Terminal · HMA Quant Strategies',
  },
};

export const extraDe = {
  ...brand,
  metrics: {
    cagr: 'CAGR',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    calmar: 'Calmar',
    maxDD: 'Max. DD',
    totalReturn: 'Gesamtrendite',
    winRate: 'Trefferquote',
    profitFactor: 'Profit-Faktor',
    volatility: 'Volatilität',
    equityCurve: 'Kapitalkurve',
    drawdown: 'Drawdown',
    annualReturns: 'Jahresrenditen',
    trades: 'Trades',
    totalTrades: 'Trades gesamt',
    expectancy: 'Erwartungswert',
    avgWin: 'Ø Gewinn',
    avgLoss: 'Ø Verlust',
    tabs: {
      equity: 'Kapitalkurve',
      drawdown: 'Drawdown',
      annual: 'Jahresrenditen',
      trades: 'Trades',
    },
  },
  cookies: {
    text: 'Wir verwenden Cookies zur Authentifizierung und zur Verbesserung des Dienstes. Wenn Sie fortfahren, stimmen Sie essenziellen Cookies zu.',
    readPolicy: 'Lesen Sie unsere',
    privacyPolicy: 'Datenschutzerklärung',
    accept: 'Akzeptieren',
    reject: 'Nicht essenzielle ablehnen',
  },
  reportCard: {
    content: 'Inhalt des Berichts',
    signalsHint: 'Signale der Strategien + Marktberichte + Quant-Macro-Notizen',
    asset: 'Asset',
    direction: 'Richtung',
    entry: 'Einstieg',
    confidence: 'Konfidenz',
  },
  questionnaire: {
    progress: 'Frage {n} von {total}',
    completePct: '{pct}% abgeschlossen',
    cancel: 'Abbrechen',
    risk_tolerance: {
      q: 'Wie hoch ist Ihre Risikotoleranz?',
      low: 'Niedrig — ich bevorzuge Kapitalerhalt',
      medium: 'Mittel — Balance aus Risiko und Rendite',
      high: 'Hoch — ich will maximale Rendite',
    },
    max_drawdown: {
      q: 'Welchen maximalen Rückgang können Sie bei Ihrer Anlage tolerieren?',
      low: 'Unter 15% — große Verluste toleriere ich nicht',
      medium: '15–30% — moderate Rückgänge sind tragbar',
      high: 'Über 30% — Drawdowns beunruhigen mich nicht',
    },
    investment_horizon: {
      q: 'Welcher ist Ihr Anlagehorizont?',
      short: 'Unter 1 Jahr',
      medium: '1–5 Jahre',
      long: 'Mehr als 5 Jahre',
    },
    investment_goal: {
      q: 'Was ist Ihr Hauptziel?',
      preservation: 'Kapital erhalten',
      income: 'Stabilen Ertrag erzielen',
      growth: 'Moderates Wachstum',
      aggressive_growth: 'Maximales Wachstum',
    },
    volatility_preference: {
      q: 'Wie stehen Sie zu Volatilität?',
      low: 'Ich bevorzuge minimale Volatilität',
      medium: 'Moderate Volatilität ist in Ordnung',
      high: 'Hohe Volatilität ist kein Problem',
    },
  },
  models: {
    conservative: {
      name: 'Konservativ',
      description: 'Geringeres Risiko, Kapitalerhalt mit moderatem Wachstum.',
      riskLevel: 'Niedrig',
      targetReturn: '12–15% pro Jahr',
      targetMaxDD: '−15% bis −20%',
    },
    moderate: {
      name: 'Moderat',
      description: 'Balance aus Risiko und Rendite über mehrere Strategietypen.',
      riskLevel: 'Mittel',
      targetReturn: '18–22% pro Jahr',
      targetMaxDD: '−20% bis −28%',
    },
    aggressive: {
      name: 'Aggressiv',
      description: 'Höheres Risiko, mehr Hebel, tiefere Drawdowns.',
      riskLevel: 'Hoch',
      targetReturn: '35–50% pro Jahr',
      targetMaxDD: '−35% bis −50%',
    },
    balanced: {
      name: 'Ausgewogen',
      description: 'Gleichgewichtete Mischung aus Timing, Momentum, Neutral und Allwetter.',
      riskLevel: 'Mittel-niedrig',
      targetReturn: '15–18% pro Jahr',
      targetMaxDD: '−18% bis −25%',
    },
    growth: {
      name: 'Wachstum',
      description: 'Langfristiges Wachstum mit kontrollierter Volatilität.',
      riskLevel: 'Mittel-hoch',
      targetReturn: '25–35% pro Jahr',
      targetMaxDD: '−25% bis −35%',
    },
    income: {
      name: 'Ertrag',
      description: 'Geringere Volatilität für einen ruhigeren Ertragsstrom.',
      riskLevel: 'Sehr niedrig',
      targetReturn: '10–13% pro Jahr',
      targetMaxDD: '−12% bis −18%',
    },
  },
  riskProfiles: {
    Low: 'Niedrig',
    'Low-Medium': 'Niedrig-mittel',
    Medium: 'Mittel',
    'Medium-High': 'Mittel-hoch',
    High: 'Hoch',
    'Very High': 'Sehr hoch',
  },
  ui: {
    snapshotSameStart: '100 = gleicher Start',
    expectedCagr: 'Erwartetes CAGR',
    expertPortfolios: 'Von Experten gestaltete Portfolios',
    comparisonTitle: 'Strategie-Vergleich',
    comparisonLead: 'Wählen Sie Strategien, um Kennzahlen nebeneinander zu vergleichen',
    riskLevel: 'Risikostufe',
    targetReturn: 'Zielrendite',
    composition: 'Zusammensetzung',
    loadingPortfolios: 'Portfolios werden geladen…',
    noSavedPortfolios: 'Noch keine gespeicherten Portfolios',
    deletePortfolioConfirm: 'Dieses Portfolio löschen?',
    portfolioDeleted: 'Portfolio gelöscht',
    deleteError: 'Löschen fehlgeschlagen',
    na: 'k. A.',
  },
  terminalApp: {
    active: 'AKTIV',
    account: 'Konto',
    exit: 'Beenden',
  },
  terminalChrome: {
    lab: 'Quant-Labor — Bildungssimulationen · keine Anlageberatung',
    modules: '{n} / {total} Module aktiv',
  },
  pageTitle: {
    quantLab: 'Quant-Labor · HMA Quant Strategies',
    terminal: 'Terminal · HMA Quant Strategies',
  },
};

export const extraIt = {
  ...brand,
  metrics: {
    cagr: 'CAGR',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    calmar: 'Calmar',
    maxDD: 'Max DD',
    totalReturn: 'Rendimento totale',
    winRate: 'Tasso di successo',
    profitFactor: 'Profit factor',
    volatility: 'Volatilità',
    equityCurve: 'Curva di capitale',
    drawdown: 'Drawdown',
    annualReturns: 'Rendimenti annuali',
    trades: 'Operazioni',
    totalTrades: 'Operazioni totali',
    expectancy: 'Aspettativa',
    avgWin: 'Guadagno medio',
    avgLoss: 'Perdita media',
    tabs: {
      equity: 'Curva di capitale',
      drawdown: 'Drawdown',
      annual: 'Rendimenti annuali',
      trades: 'Operazioni',
    },
  },
  cookies: {
    text: 'Usiamo cookie per l’autenticazione e per migliorare il servizio. Continuando, accetti i cookie essenziali.',
    readPolicy: 'Leggi la nostra',
    privacyPolicy: 'Informativa sulla privacy',
    accept: 'Accetta',
    reject: 'Rifiuta i non essenziali',
  },
  reportCard: {
    content: 'Contenuto del report',
    signalsHint: 'Segnali delle strategie + report di mercato + visioni Quant Macro',
    asset: 'Attivo',
    direction: 'Direzione',
    entry: 'Ingresso',
    confidence: 'Fiducia',
  },
  questionnaire: {
    progress: 'Domanda {n} di {total}',
    completePct: '{pct}% completato',
    cancel: 'Annulla',
    risk_tolerance: {
      q: 'Qual è la tua tolleranza al rischio?',
      low: 'Bassa — preferisco preservare il capitale',
      medium: 'Media — equilibrio tra rischio e rendimento',
      high: 'Alta — cerco il massimo rendimento',
    },
    max_drawdown: {
      q: 'Quale calo massimo puoi tollerare nell’investimento?',
      low: 'Meno del 15% — non tollero grandi perdite',
      medium: '15–30% — posso sopportare cali moderati',
      high: 'Più del 30% — i drawdown non mi preoccupano',
    },
    investment_horizon: {
      q: 'Qual è il tuo orizzonte di investimento?',
      short: 'Meno di 1 anno',
      medium: '1–5 anni',
      long: 'Più di 5 anni',
    },
    investment_goal: {
      q: 'Qual è il tuo obiettivo principale?',
      preservation: 'Preservare il capitale',
      income: 'Generare un reddito stabile',
      growth: 'Crescita moderata',
      aggressive_growth: 'Crescita massima',
    },
    volatility_preference: {
      q: 'Come ti senti rispetto alla volatilità?',
      low: 'Preferisco la volatilità minima',
      medium: 'La volatilità moderata va bene',
      high: 'L’alta volatilità non è un problema',
    },
  },
  models: {
    conservative: {
      name: 'Conservativo',
      description: 'Rischio più basso, preservazione del capitale con crescita moderata.',
      riskLevel: 'Basso',
      targetReturn: '12–15% all’anno',
      targetMaxDD: '−15% a −20%',
    },
    moderate: {
      name: 'Moderato',
      description: 'Equilibrio tra rischio e rendimento tra diversi tipi di strategia.',
      riskLevel: 'Medio',
      targetReturn: '18–22% all’anno',
      targetMaxDD: '−20% a −28%',
    },
    aggressive: {
      name: 'Aggressivo',
      description: 'Più rischio, più leva, drawdown più profondi.',
      riskLevel: 'Alto',
      targetReturn: '35–50% all’anno',
      targetMaxDD: '−35% a −50%',
    },
    balanced: {
      name: 'Bilanciato',
      description: 'Mix a pesi uguali di timing, momentum, neutrale e all-weather.',
      riskLevel: 'Medio-basso',
      targetReturn: '15–18% all’anno',
      targetMaxDD: '−18% a −25%',
    },
    growth: {
      name: 'Crescita',
      description: 'Crescita di lungo periodo con una manica di volatilità controllata.',
      riskLevel: 'Medio-alto',
      targetReturn: '25–35% all’anno',
      targetMaxDD: '−25% a −35%',
    },
    income: {
      name: 'Reddito',
      description: 'Mix a bassa volatilità per un flusso di rendimento più regolare.',
      riskLevel: 'Molto basso',
      targetReturn: '10–13% all’anno',
      targetMaxDD: '−12% a −18%',
    },
  },
  riskProfiles: {
    Low: 'Basso',
    'Low-Medium': 'Basso-medio',
    Medium: 'Medio',
    'Medium-High': 'Medio-alto',
    High: 'Alto',
    'Very High': 'Molto alto',
  },
  ui: {
    snapshotSameStart: '100 = stesso inizio',
    expectedCagr: 'CAGR atteso',
    expertPortfolios: 'Portafogli progettati da esperti',
    comparisonTitle: 'Confronto tra strategie',
    comparisonLead: 'Seleziona le strategie per confrontare le metriche di performance',
    riskLevel: 'Livello di rischio',
    targetReturn: 'Rendimento obiettivo',
    composition: 'Composizione',
    loadingPortfolios: 'Caricamento portafogli…',
    noSavedPortfolios: 'Nessun portafoglio salvato',
    deletePortfolioConfirm: 'Eliminare questo portafoglio?',
    portfolioDeleted: 'Portafoglio eliminato',
    deleteError: 'Impossibile eliminare',
    na: 'N/D',
  },
  terminalApp: {
    active: 'ATTIVO',
    account: 'Account',
    exit: 'Esci',
  },
  terminalChrome: {
    lab: 'Lab quantitativo — simulazioni educative · non è consulenza di investimento',
    modules: '{n} / {total} moduli attivi',
  },
  pageTitle: {
    quantLab: 'Lab quantitativo · HMA Quant Strategies',
    terminal: 'Terminale · HMA Quant Strategies',
  },
};

export const extraPl = {
  ...brand,
  metrics: {
    cagr: 'CAGR',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    calmar: 'Calmar',
    maxDD: 'Maks. DD',
    totalReturn: 'Całkowity zwrot',
    winRate: 'Skuteczność',
    profitFactor: 'Profit factor',
    volatility: 'Zmienność',
    equityCurve: 'Krzywa kapitału',
    drawdown: 'Drawdown',
    annualReturns: 'Stopy roczne',
    trades: 'Transakcje',
    totalTrades: 'Liczba transakcji',
    expectancy: 'Oczekiwana wartość',
    avgWin: 'Śr. zysk',
    avgLoss: 'Śr. strata',
    tabs: {
      equity: 'Krzywa kapitału',
      drawdown: 'Drawdown',
      annual: 'Stopy roczne',
      trades: 'Transakcje',
    },
  },
  cookies: {
    text: 'Używamy plików cookie do uwierzytelniania i poprawy usługi. Kontynuując, wyrażasz zgodę na niezbędne pliki cookie.',
    readPolicy: 'Przeczytaj naszą',
    privacyPolicy: 'Politykę prywatności',
    accept: 'Akceptuję',
    reject: 'Odrzuć zbędne',
  },
  reportCard: {
    content: 'Treść raportu',
    signalsHint: 'Sygnały strategii + raporty rynkowe + notatki Quant Macro',
    asset: 'Aktywo',
    direction: 'Kierunek',
    entry: 'Wejście',
    confidence: 'Pewność',
  },
  questionnaire: {
    progress: 'Pytanie {n} z {total}',
    completePct: '{pct}% ukończone',
    cancel: 'Anuluj',
    risk_tolerance: {
      q: 'Jaka jest Twoja tolerancja ryzyka?',
      low: 'Niska — wolę chronić kapitał',
      medium: 'Średnia — równowaga ryzyka i zwrotu',
      high: 'Wysoka — chcę maksymalnego zwrotu',
    },
    max_drawdown: {
      q: 'Jaki maksymalny spadek możesz zaakceptować?',
      low: 'Poniżej 15% — nie toleruję dużych strat',
      medium: '15–30% — umiarkowane spadki są do przyjęcia',
      high: 'Powyżej 30% — drawdowny mnie nie niepokoją',
    },
    investment_horizon: {
      q: 'Jaki jest Twój horyzont inwestycyjny?',
      short: 'Mniej niż 1 rok',
      medium: '1–5 lat',
      long: 'Ponad 5 lat',
    },
    investment_goal: {
      q: 'Jaki jest Twój główny cel?',
      preservation: 'Ochrona kapitału',
      income: 'Stabilny strumień dochodu',
      growth: 'Umiarkowany wzrost',
      aggressive_growth: 'Maksymalny wzrost',
    },
    volatility_preference: {
      q: 'Jak znosisz zmienność?',
      low: 'Wolę minimalną zmienność',
      medium: 'Umiarkowana zmienność jest w porządku',
      high: 'Wysoka zmienność nie jest problemem',
    },
  },
  models: {
    conservative: {
      name: 'Konserwatywny',
      description: 'Niższe ryzyko, ochrona kapitału z umiarkowanym wzrostem.',
      riskLevel: 'Niskie',
      targetReturn: '12–15% rocznie',
      targetMaxDD: '−15% do −20%',
    },
    moderate: {
      name: 'Umiarkowany',
      description: 'Równowaga ryzyka i zwrotu między różnymi typami strategii.',
      riskLevel: 'Średnie',
      targetReturn: '18–22% rocznie',
      targetMaxDD: '−20% do −28%',
    },
    aggressive: {
      name: 'Agresywny',
      description: 'Wyższe ryzyko, większa dźwignia, głębsze drawdowny.',
      riskLevel: 'Wysokie',
      targetReturn: '35–50% rocznie',
      targetMaxDD: '−35% do −50%',
    },
    balanced: {
      name: 'Zrównoważony',
      description: 'Równe wagi timingu, momentum, market-neutral i all-weather.',
      riskLevel: 'Średnio-niskie',
      targetReturn: '15–18% rocznie',
      targetMaxDD: '−18% do −25%',
    },
    growth: {
      name: 'Wzrostowy',
      description: 'Długoterminowy wzrost z kontrolowaną zmiennością.',
      riskLevel: 'Średnio-wysokie',
      targetReturn: '25–35% rocznie',
      targetMaxDD: '−25% do −35%',
    },
    income: {
      name: 'Dochodowy',
      description: 'Niższa zmienność, bardziej płynny strumień stóp zwrotu.',
      riskLevel: 'Bardzo niskie',
      targetReturn: '10–13% rocznie',
      targetMaxDD: '−12% do −18%',
    },
  },
  riskProfiles: {
    Low: 'Niskie',
    'Low-Medium': 'Nisko-średnie',
    Medium: 'Średnie',
    'Medium-High': 'Średnio-wysokie',
    High: 'Wysokie',
    'Very High': 'Bardzo wysokie',
  },
  ui: {
    snapshotSameStart: '100 = ten sam start',
    expectedCagr: 'Oczekiwany CAGR',
    expertPortfolios: 'Portfele zaprojektowane przez ekspertów',
    comparisonTitle: 'Porównanie strategii',
    comparisonLead: 'Wybierz strategie, aby porównać metryki obok siebie',
    riskLevel: 'Poziom ryzyka',
    targetReturn: 'Docelowy zwrot',
    composition: 'Skład',
    loadingPortfolios: 'Ładowanie portfeli…',
    noSavedPortfolios: 'Brak zapisanych portfeli',
    deletePortfolioConfirm: 'Usunąć ten portfel?',
    portfolioDeleted: 'Portfel usunięty',
    deleteError: 'Nie udało się usunąć',
    na: 'bd.',
  },
  terminalApp: {
    active: 'AKTYWNY',
    account: 'Konto',
    exit: 'Wyjście',
  },
  terminalChrome: {
    lab: 'Lab ilościowy — symulacje edukacyjne · to nie jest porada inwestycyjna',
    modules: '{n} / {total} aktywnych modułów',
  },
  pageTitle: {
    quantLab: 'Lab ilościowy · HMA Quant Strategies',
    terminal: 'Terminal · HMA Quant Strategies',
  },
};

export const extraZh = {
  ...brand,
  metrics: {
    cagr: 'CAGR',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    calmar: 'Calmar',
    maxDD: '最大回撤',
    totalReturn: '总回报',
    winRate: '胜率',
    profitFactor: '盈亏比',
    volatility: '波动率',
    equityCurve: '权益曲线',
    drawdown: '回撤',
    annualReturns: '年度收益',
    trades: '交易',
    totalTrades: '交易笔数',
    expectancy: '期望值',
    avgWin: '平均盈利',
    avgLoss: '平均亏损',
    tabs: {
      equity: '权益曲线',
      drawdown: '回撤',
      annual: '年度收益',
      trades: '交易',
    },
  },
  cookies: {
    text: '我们使用 Cookie 进行身份验证并改进服务。继续使用即表示您同意必要 Cookie。',
    readPolicy: '请阅读我们的',
    privacyPolicy: '隐私政策',
    accept: '接受',
    reject: '拒绝非必要项',
  },
  reportCard: {
    content: '报告内容',
    signalsHint: '各策略信号 + 市场报告 + Quant Macro 观点',
    asset: '标的',
    direction: '方向',
    entry: '入场',
    confidence: '置信度',
  },
  questionnaire: {
    progress: '第 {n} 题，共 {total} 题',
    completePct: '已完成 {pct}%',
    cancel: '取消',
    risk_tolerance: {
      q: '你的风险承受能力如何？',
      low: '低 — 我更希望保全本金',
      medium: '中 — 在风险与回报之间平衡',
      high: '高 — 我追求最高回报',
    },
    max_drawdown: {
      q: '你能承受的最大跌幅是多少？',
      low: '低于 15% — 无法接受大幅亏损',
      medium: '15–30% — 可以承受中等回撤',
      high: '超过 30% — 回撤不会让我担心',
    },
    investment_horizon: {
      q: '你的投资期限是多久？',
      short: '不到 1 年',
      medium: '1–5 年',
      long: '5 年以上',
    },
    investment_goal: {
      q: '你的主要目标是什么？',
      preservation: '保全本金',
      income: '获得稳定现金流',
      growth: '稳健增长',
      aggressive_growth: '最大化增长',
    },
    volatility_preference: {
      q: '你如何看待波动？',
      low: '希望波动尽量小',
      medium: '中等波动可以接受',
      high: '高波动不是问题',
    },
  },
  models: {
    conservative: {
      name: '稳健',
      description: '较低风险，保全本金并追求温和增长。',
      riskLevel: '低',
      targetReturn: '每年 12–15%',
      targetMaxDD: '−15% 至 −20%',
    },
    moderate: {
      name: '均衡',
      description: '在多种策略类型之间平衡风险与回报。',
      riskLevel: '中',
      targetReturn: '每年 18–22%',
      targetMaxDD: '−20% 至 −28%',
    },
    aggressive: {
      name: '进取',
      description: '更高风险、更高杠杆、更深回撤。',
      riskLevel: '高',
      targetReturn: '每年 35–50%',
      targetMaxDD: '−35% 至 −50%',
    },
    balanced: {
      name: '平衡',
      description: '择时、动量、市场中性与全天候等权组合。',
      riskLevel: '中低',
      targetReturn: '每年 15–18%',
      targetMaxDD: '−18% 至 −25%',
    },
    growth: {
      name: '成长',
      description: '长期成长，并控制波动敞口。',
      riskLevel: '中高',
      targetReturn: '每年 25–35%',
      targetMaxDD: '−25% 至 −35%',
    },
    income: {
      name: '收益',
      description: '较低波动，追求更平滑的回报路径。',
      riskLevel: '极低',
      targetReturn: '每年 10–13%',
      targetMaxDD: '−12% 至 −18%',
    },
  },
  riskProfiles: {
    Low: '低',
    'Low-Medium': '中低',
    Medium: '中',
    'Medium-High': '中高',
    High: '高',
    'Very High': '极高',
  },
  ui: {
    snapshotSameStart: '100 = 同一起点',
    expectedCagr: '预期 CAGR',
    expertPortfolios: '专家设计的组合',
    comparisonTitle: '策略对比',
    comparisonLead: '选择策略以并排比较绩效指标',
    riskLevel: '风险等级',
    targetReturn: '目标回报',
    composition: '构成',
    loadingPortfolios: '正在加载组合…',
    noSavedPortfolios: '还没有已保存的组合',
    deletePortfolioConfirm: '删除此组合？',
    portfolioDeleted: '组合已删除',
    deleteError: '无法删除',
    na: '暂无',
  },
  terminalApp: {
    active: '运行中',
    account: '账户',
    exit: '退出',
  },
  terminalChrome: {
    lab: '量化实验室 — 教学模拟 · 不构成投资建议',
    modules: '{n} / {total} 个模块已启用',
  },
  pageTitle: {
    quantLab: '量化实验室 · HMA Quant Strategies',
    terminal: '终端 · HMA Quant Strategies',
  },
};
